// extracted by mini-css-extract-plugin
export default {"page-heading":"PageHeading_page-heading__uhXy6"};